export default __webpack_public_path__ + "static/media/logo-lg-480w.e2ed832b.webp";